// in the lightTheme the color should be black whereas in darkTheme the color should be white

import { createTheme, tableCellClasses } from "@mui/material";

export const darkTheme = createTheme({
  palette: {
    // mode: "dark",
    // action: {
    //   active: "#3366ff",
    //   hover: "#598bff",
    //   selected: "#3366ff",
    // },
    background: {
      default: "#151a30",
      paper: "#222B45",
    },
    text: {
      primary: "#222b45",
      secondary: "#8f9bb3",
    },
    divider: "#151a30",
    primary: {
      main: "#222b45",
    },
    secondary: {
      main: "#ffffff",
    },
    navbarIconColor: {
      main: "#8f9bb3",
    },
    sideBarButton: {
      main: "#598bff",
    },
    otherColor: {
      main: "#000000",
    },
    scrollbar: {
      primary: "#101426",
      secondary: "#192038",
    },
    box: {
      primary: "#192038",
      secondary: "#edf1f7",
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          border: "1px solid #192038",
          backgroundColor: "#222b45",
          borderLeft: "none",
          borderRight: "none",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& label.Mui-focused": {
            color: "#d5d9de",
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#101426",
            },
            "&:hover fieldset": {
              borderColor: "#101426",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#101426",
            },
            backgroundColor: "#101426",
            "&:hover": {
              backgroundColor: "#192038",
            },
          },
        },
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          "&.Mui-active": {
            color: "#36f",
          },
          "&.Mui-completed": {
            color: "green",
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          [`&.${tableCellClasses.head}`]: {
            backgroundColor: "#222b45",
            border: "1px solid #151a30",
            fontSize: "15px",
          },
          [`&.${tableCellClasses.body}`]: {
            fontSize: "15px",
            border: "1px solid #151a30",
          },
          color: "#ffffff",
          fontFamily: "'Open Sans', sans-serif",
          whiteSpace: "nowrap",
        },
      },
    },

    MuiTableRow: {
      styleOverrides: {
        root: {
          border: "1px solid #151a30",
          "&:nth-of-type(odd)": {
            backgroundColor: "#192038",
          },
          "&:hover": {
            backgroundColor: "#151a30",
          },
          whiteSpace: "nowrap",
        },
      },
    },

    // MuiLinearProgress: {
    //   styleOverrides: {
    //     colorPrimary: {
    //       backgroundColor: "#EDF1F7",
    //     },
    //     bar: {
    //       borderRadius: 5,
    // backgroundColor:
    //   theme.palette.mode === "light" ? "#1a90ff" : "#308fe8",
    // },

    // height: 20,
    // borderRadius: 5,
    //     },
    //   },
  },
  typography: {
    allVariants: {
      fontFamily: "Open Sans,sans-serif",
    },
    body1: {
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: 1.5,
      color: "#ffffff",
      fontFamily: "Open Sans,sans-serif",
    },
    body2: {
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: 1.57,
      color: "#ffffff",
      fontFamily: "Open Sans,sans-serif",
    },
    body3: {
      fontWeight: 700,
      fontSize: "2rem",
      lineHeight: 1.375,
      color: "#ffffff",
      fontFamily: "Open Sans,sans-serif",
    },
    h1: {
      fontSize: "28px",
      fontWeight: 400,
      lineHeight: "24px",
      cursor: "pointer",
      color: "#ffffff",
    },
    h2: {
      color: "#ffffff",
    },
    h3: {
      color: "#ffffff",
    },
    h4: {
      fontSize: "15px",
      fontWeight: 600,
      lineHeight: "1.5rem",
      color: "#ffffff",
    },
    h5: {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "24px",
      fontFamily: "'Open Sans', sans-serif",
      color: "#ffffff",
    },
    h6: {
      color: "#ffffff",
    },
  },
});

export const lightTheme = createTheme({
  palette: {
    // action: {
    //   active: "#3366ff",
    //   hover: "#598bff",
    //   selected: "#3366ff",
    // },
    background: {
      default: "#EDf1f7",
      paper: "#ffffff",
    },
    text: {
      primary: "#222b45",
      secondary: "#8f9bb3",
    },
    divider: "#EDf1f7",
    primary: {
      main: "#ffffff",
      light: "#ff0000",
    },
    secondary: {
      main: "#222b45",
    },
    navbarIconColor: {
      main: "#8f9bb3",
    },
    sideBarButton: {
      main: "#598bff",
    },
    otherColor: {
      main: "#000000",
    },
    scrollbar: {
      primary: "#e4e9f2",
      secondary: "#f7f9fc",
    },
    box: {
      primary: "#f7f9fc",
      secondary: "#edf1f7",
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          border: "1px solid #e4e9f2",
          // backgroundColor: "#f7f9fc",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& label.Mui-focused": {
            color: "#222b45",
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#d5d9de",
            },
            "&:hover fieldset": {
              borderColor: "#d5d9de",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#d5d9de",
            },
            backgroundColor: "#f7f9fc",
            "&:hover": {
              backgroundColor: "#edf1f7",
            },
          },
        },
      },
    },

    MuiStepIcon: {
      styleOverrides: {
        root: {
          "&.Mui-active": {
            color: "#edf1f7",
          },
          "&.Mui-completed": {
            color: "green",
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          [`&.${tableCellClasses.head}`]: {
            backgroundColor: "#90ee90",
            border: "1px solid #edf1f7",
            fontSize: "15px",
          },
          [`&.${tableCellClasses.body}`]: {
            fontSize: "15px",
            border: "1px solid #edf1f7",
          },
          color: "#222b45",
          fontFamily: "'Open Sans', sans-serif",
          whiteSpace: "nowrap",
        },
      },
    },

    MuiTableRow: {
      styleOverrides: {
        root: {
          border: "1px solid #edf1f7",
          "&:nth-of-type(odd)": {
            backgroundColor: "#f7f9fc",
          },
          "&:hover": {
            backgroundColor: "#edf1f7",
          },
          whiteSpace: "nowrap",
        },
      },
    },
    // MuiSelect: {
    //   styleOverrides: {
    //     // icon: {
    //     //   color: "#ff0000",
    //     // },
    //     select: {
    //       border: "1px solid #ff0000",
    //     },
    //   },
    // },
  },
  typography: {
    allVariants: {
      fontFamily: "Open Sans,sans-serif",
    },
    body1: {
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: 1.5,
      color: "#222b45",
      fontFamily: "'Open Sans', sans-serif",
    },
    body2: {
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: 1.57,
      color: "#222b45",
      fontFamily: "'Open Sans', sans-serif",
    },
    body3: {
      fontWeight: 700,
      fontSize: "2rem",
      lineHeight: 1.375,
      color: "#222b45",
      fontFamily: "'Open Sans', sans-serif",
    },
    h1: {
      fontSize: "28px",
      fontWeight: 400,
      lineHeight: "24px",
      cursor: "pointer",
      color: "##222b45",
    },
    h2: {
      fontFamily: "'Open Sans', sans-serif",
      fontSize: "25px",
      fontWeight: 600,
      lineHeight: "24px",
      color: "#222b45",
    },
    h3: {
      color: "#222b45",
      fontWeight: 600,
      fontSize: "20px",
      fontFamily: "'Open Sans', sans-serif",
    },
    h4: {
      fontSize: "15px",
      fontWeight: 600,
      fontFamily: "'Open Sans', sans-serif",
      lineHeight: "1.5rem",
      color: "#222b45",
    },
    h5: {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "24px",
      fontFamily: "'Open Sans', sans-serif",
      color: "#222b45",
    },
    h6: {
      fontFamily: "'Open Sans', sans-serif",
      color: "#222b45",
    },
  },
});

// for dark
// MuiButton: {
//   variants: [
//     {
//       props: { variant: "contained", color: "#ff3d71" },
//       style: {
//         // backgroundColor: "#ff3d71",
//         // color: "#fff",
//         borderColor: "#ff3d71",
//       },
//     },
//     {
//       props: { variant: "contained" },
//       style: {
//         // color: "yellow",
//       },
//     },
//   ],
// },
// MuiInputLabel: {
//   styleOverrides: {
//     // focused: {
//     //   color: "#fff",
//     // },
//     "& .Mui-focused	": {},
//   },
// },

// for light
// MuiButton: {
//   variants: [
//     {
//       props: { variant: "contained" },
//       style: {
//         // backgroundColor: "#ff3d71",
//         color: "#fff",
//         borderColor: "#ff3d71",
//       },
//     },
//     {
//       props: { variant: "grey" },
//       style: {
//         // color: "yellow",
//       },
//     },
//   ],
// },
